export default "__VITE_ASSET__BD4_I2un__"